import React from 'react'
import CGUPage from '../parts/pages/CGUPage'

export default function CGU() {
  return <CGUPage />
}
